import React, { useEffect, ReactNode } from "react";
import {
  makeStyles,
  createStyles,
  Button
  // ButtonGroup
} from "@material-ui/core";
import classnames from "classnames";
import { useLocation, useHistory } from "react-router-dom";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { ITheme } from "../../Layout/themes";
import { commonStaticContentStyles } from "./index";
import {
  IRecipientTicketInfo,
  ShareStatus,
  AuthEndpoints,
  IEnvironment
} from "../../../interface/IShareInfo";
import { updatePostStep, acceptTicket, declineTicket } from "./actions";
import { signOut } from "../../Pages/SignIn/actions";
import { addToken } from "../../../commons/utils/addToken";
import { showLoading } from "../../Ui/ConnectedFullscreenLoader/actions";

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    root: {
      marginTop: "1rem"
    },
    btn: {
      ...commonStaticContentStyles.button,
      width: "100%",
      display: "block"
    },
    successBtn: {
      height: "60px",
      backgroundColor: palette.success.main,
      color: "#fff",
      marginTop: "1rem",
      "&:hover": {
        backgroundColor: palette.success.dark
      }
    },
    infoBtn: {
      border: "solid 1px rgba(0, 0, 0, 0.1)",
      marginTop: "1rem",
      height: "60px",
    }
  });
});

interface IProps {
  loading: boolean;
  isAuthenticated: () => boolean;
  recipientTicketInfo: IRecipientTicketInfo;
  updatePostStep: (postStep: string) => void;
  acceptTicket: () => void;
  declineTicket: () => void;
  resetAuth: () => void;
  showLoading: (loadingText?: string) => void;
  env: IEnvironment;
}

interface IBtnProps {
  onClick?: () => void;
  children: string;
}

const SuccessBtn = ({ onClick, children }: IBtnProps) => {
  const classes = useStyles({});
  return (
    <Button
      variant="contained"
      color="secondary"
      className={classnames([classes.btn, classes.successBtn])}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

const InfoBtn = ({ onClick, children }: IBtnProps) => {
  const classes = useStyles({});
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={classnames([classes.btn, classes.infoBtn])}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

const ButtonGroupComponent = ({
  loading,
  isAuthenticated,
  recipientTicketInfo,
  updatePostStep,
  acceptTicket,
  resetAuth,
  declineTicket,
  showLoading,
  env
}: IProps) => {
  const classes = useStyles({});
  const location = useLocation();
  const history = useHistory();

  const isUserSignedIn = isAuthenticated();


  if (loading) {
    return <div />;
  }

  const handleSignedOut = (method: AuthEndpoints) => () => {
    updatePostStep("accept");
    if (method === AuthEndpoints.Login) {
      history.push(
        `/${method}?redirectUrl=${location.pathname}&${location.search.slice(
          1
        )}`
      );
    } else if (method === AuthEndpoints.Signup) {
      history.push(
        `/${method}?redirectUrl=${location.pathname}&${location.search.slice(
          1
        )}`
      );
    }
  };

  const handleAcceptTicket = () => {
    acceptTicket();
  };

  const handleDeclineTicket = () => {
    declineTicket();
  };
  const  handleResetAuth = () => {
    resetAuth();
  };

  const handleViewMobilTicket = () => {
    const index = location.search.indexOf("mobiUrl=");
    if (index > -1) {
      const url = location.search.slice(index + "mobiUrl=".length);
      showLoading("Loading your ticket...");
      window.location.href = addToken(url);
    }
  };

  const handleRedirect2OrderHistory = () => {
    window.location.href = env.ORDER_HISTORY_URL;
  };

  const handleRedirect2Homepage = () => {
    window.location.href = env.HOMEPAGE_URL;
  };

  if (!isUserSignedIn) {
    return (
      <div className={classes.root}>
        <SuccessBtn onClick={handleSignedOut(AuthEndpoints.Login)}>
          Sign in and accept
        </SuccessBtn>
        <InfoBtn onClick={handleSignedOut(AuthEndpoints.Signup)}>
          Create account
        </InfoBtn>
        {/* <InfoBtn onClick={handleDeclineTicket}>Decline</InfoBtn> */}
      </div>
    );
  }

  if (
    recipientTicketInfo &&
    recipientTicketInfo.shareStatus === ShareStatus.Accepted
  ) {
    return (
      <div className={classes.root}>
        <SuccessBtn onClick={handleViewMobilTicket}>View ticket</SuccessBtn>
        {/* <InfoBtn onClick={handleRedirect2OrderHistory}>Order History</InfoBtn>
        <InfoBtn onClick={handleRedirect2Homepage}>Homepage</InfoBtn> */}
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <SuccessBtn onClick={handleAcceptTicket}>Accept</SuccessBtn>
      {/* <InfoBtn onClick={handleDeclineTicket}>Decline</InfoBtn> */}
      <InfoBtn onClick={handleResetAuth}>
          Sign in as another user
        </InfoBtn>
    </div>
  );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    updatePostStep: (postStep: string) => dispatch(updatePostStep(postStep)),
    acceptTicket: () => dispatch(acceptTicket()),
    declineTicket: () => dispatch(declineTicket()),
    resetAuth: () => dispatch(signOut()),
    showLoading: (loadingText?: string) => dispatch(showLoading(loadingText))

  };
};

const mapStateToProps = (state) => ({
  env: state.env
});
export const ButtonGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonGroupComponent);
